import { render } from "./RulesPane.vue?vue&type=template&id=060b59b4&scoped=true"
import script from "./RulesPane.vue?vue&type=script&lang=js"
export * from "./RulesPane.vue?vue&type=script&lang=js"

import "./RulesPane.vue?vue&type=style&index=0&id=060b59b4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060b59b4"]])

export default __exports__